import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredArticles = articles.slice(0, 4);

const featuredImages: Record<string, string> = {
  'huangyou-xiashuo-chuchu': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20scrolls%20and%20bamboo%20slips%20with%20calligraphy%2C%20warm%20lighting%2C%20scholarly%20atmosphere%2C%20traditional%20Chinese%20study%20room%2C%20ink%20and%20brush%20on%20wooden%20desk%2C%20soft%20natural%20light%2C%20elegant%20and%20refined%20composition&width=400&height=280&seq=art-chuchu-01&orientation=landscape',
  'huangyou-xiashuo-gushi': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20warrior%20scholar%20in%20traditional%20robes%20holding%20a%20halberd%2C%20ancient%20Chinese%20courtyard%2C%20autumn%20leaves%2C%20misty%20atmosphere%2C%20ink%20wash%20painting%20style%2C%20elegant%20and%20serene%20mood&width=400&height=280&seq=art-gushi-01&orientation=landscape',
  'huangyou-xiashuo-xiangzheng': 'https://readdy.ai/api/search-image?query=Symbolic%20ancient%20Chinese%20halberd%20weapon%20resting%20against%20a%20stone%20wall%2C%20soft%20diffused%20lighting%2C%20minimalist%20composition%2C%20ink%20wash%20aesthetic%2C%20serene%20and%20contemplative%20atmosphere&width=400&height=280&seq=art-xiangzheng-01&orientation=landscape',
  'huangyou-xiashuo-zhexue': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20philosophy%20scene%2C%20abstract%20ink%20wash%20landscape%20with%20misty%20mountains%2C%20contemplative%20atmosphere%2C%20Taoist%20philosophy%20concept%2C%20minimalist%20composition%2C%20serene%20and%20profound%20mood&width=400&height=280&seq=art-zhexue-01&orientation=landscape',
};

export default function FeaturedArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              精选文章
            </h2>
            <p className="text-foreground-500 text-sm">
              深度好文，带您领略黄游下戟的文化魅力
            </p>
          </div>
          <Link
            to="/category/chuchu"
            className="hidden sm:flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featuredArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col sm:flex-row gap-5 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full sm:w-[200px] h-44 sm:h-auto flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={featuredImages[article.id] || ''}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={index > 1 ? 'lazy' : undefined}
                />
              </div>
              <div className="flex-1 flex flex-col justify-between min-w-0">
                <div>
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-2">
                    {article.category}
                  </span>
                  <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.publishDate}</span>
                  <span>·</span>
                  <span>{article.readTime} 分钟阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}